
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockCountTranDialog extends Serenity.Extensions.GridEditorDialog<IcStockCountTranRow> {
        protected getFormKey() { return IcStockCountTranForm.formKey; }
        // protected getIdProperty() { return IcStockCountTranRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockCountTranRow.localTextPrefix; }
        protected getNameProperty() { return IcStockCountTranRow.nameProperty; }
        // protected getService() { return IcStockCountTranService.baseUrl; }
        // protected getDeletePermission() { return IcStockCountTranRow.deletePermission; }
        // protected getInsertPermission() { return IcStockCountTranRow.insertPermission; }
        // protected getUpdatePermission() { return IcStockCountTranRow.updatePermission; }

        protected form = new IcStockCountTranForm(this.idPrefix);

        public qnNo: number;
        public purprice: number;
        public sku: string;


        constructor() {
            super();

            this.form = new IcStockCountTranForm(this.idPrefix);
            this.form.PluCode.changeSelect2
                (e => {
                    var plucode = Q.toId(this.form.PluCode.value);
                    var plu : string = this.form.PluCode.value
                    if (plucode != null) {
                        Serenity.EditorUtils.setReadonly(this.form.QtyCount.element, false);

                        this.form.SellUnit.value = Product.CsPluRow.getLookup().itemById[plu].SellUnit;
                        this.form.SellUnitRatio.value = Product.CsPluRow.getLookup().itemById[plu].SellUnitRatio;
                        this.form.ItemRemark.value = Product.CsPluRow.getLookup().itemById[plu].PluDesc;
                        this.form.SkuCode.value = Product.CsPluRow.getLookup().itemById[plu].SkuCode;
                        this.sku = Product.CsPluRow.getLookup().itemById[plu].SkuCode;

                        if (this.form.SkuCode.value != null) {
                            
                            this.form.PurUnitRatio.value = Product.CsSkuRow.getLookup().itemById[this.sku].PurUnitRatio;
                            this.form.PurUnitPrice.value = Product.CsSkuRow.getLookup().itemById[this.sku].PurUnitPrice;

                        }

                    }
                });
            this.form.QtyCount.changeSelect2
                (e => {
                    var QtyCount = Q.toId(this.form.QtyCount.value);
                    if (QtyCount != null) {
                        this.form.StkQtyCount.value = (this.form.QtyCount.value || 0) * (this.form.SellUnitRatio.value || 1);


                    }
                });

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);


            let newBtn: Serenity.ToolButton =
            {
                title: "บันทึกและสร้างรายการถัดไป",
                hint: "Save and new",
                separator: false,
                cssClass: "button-saveandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: (e) => {

                    if(!Q.isEmptyOrNull(this.form.SkuCode.value)){
                        e.preventDefault();
                    this.saveAndNew();
                    }else{
                        Q.warning("โปรดใส่รหัส Skuก่อน")
                    }
                    
                }
            };
            buttons.push(newBtn);

            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            this.save((response) => {
                let ent: IcStockCountTranRow = { SkuCode: e.SkuCode };
                this.loadEntity(ent);
            });
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew) {
                Serenity.EditorUtils.setReadonly(this.form.QtyCount.element, true);
            }
            var thisId = Q.toId(this.form.Id.value);
            if (thisId < 0) {
                let self = this;
                self.toolbar.findButton('button-saveandnew').toggleClass('disabled', true);
            }

        }
         // protected getCssClass() {
        //     super.getCssClass();
        //     return "fixRight";

        // }



    }
}